(function () {
    let nearbyItems = document.querySelectorAll('.nearby-type');
    let filterPharmacyForm = document.querySelector("#filterPharmacyForm");

    /****************************************************
     * toggle click closest recommended / any rating
     ***************************************************/
    nearbyItems.forEach(item => {
        item.addEventListener('click', function() {
            nearbyItems.forEach(i => i.classList.remove('active'));
            this.classList.add('active');
            let clickedItemId = this.id;
            if( document.querySelector(".pharmacy-result-title") ) {
                if( clickedItemId == 'rating' ) {
                    document.querySelector(".pharmacy-result-title").innerHTML = "Closest Any Rating";
                } else {
                    document.querySelector(".pharmacy-result-title").innerHTML = "Closest Recommended";
                }
            }
            document.querySelector("#pharmacy-search-type").value = clickedItemId;

            const filterDivs = {
                recommended: document.querySelector('.pharmacy-result-recommended '),
                rating: document.querySelector('.pharmacy-result-rating')
            };

            Object.values(filterDivs).forEach(div => div.classList.add('noshow'));

            if (filterDivs[clickedItemId]) {
                filterDivs[clickedItemId].classList.remove('noshow');
            }

            let clickSubmit = document.querySelector("#click-submit").value;
            if( clickSubmit != '' ) {
                let pharmacyFilterElement = document.querySelector("#pharmacy-filter-nearby");
                pharmacyFilterElement.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
        });
    });

    /****************************************
     * on submit pharmacy filter form
     ***************************************/
    if (filterPharmacyForm) {
        filterPharmacyForm.addEventListener("submit", (e) => {
            e.preventDefault();
            
            let searchInput = document.querySelector('#map-input');
            let mobileNumber = document.querySelector("#filterPharmacyForm #patientMobile");
            let filterType = document.querySelector("#filterPharmacyForm #pharmacy-search-type"); 
            let searchLat = document.querySelector("#filterPharmacyForm #search-lat"); 
            let searchLng = document.querySelector("#filterPharmacyForm #search-lng");
            let finderModalTrigger = document.querySelector("#pharmacy-finder-modal-trigger");
            let departureDate = document.querySelector("#filterPharmacyForm #departure-date");
            let popModalMessage = document.querySelector(".message-text");

            finderModalTrigger.click();

            if( searchInput.value == '' ) {
                glide_ajax_loader_hide();
                popModalMessage.innerHTML = '<p>Enter location address.</p>';
                return;
            } else {
                glide_ajax_loader_hide();
                if ( searchLat.value == "" || searchLng.value == "" ) {
                    popModalMessage.innerHTML = '<p>Could not locate address.<br> Try enter another address.</p>';
                    return;
                }
            }

            if ( mobileNumber.value == "" ) {
                glide_ajax_loader_hide();
                popModalMessage.innerHTML = "<p>Enter patient mobile number.</p>";
                return;
            } else {
                if( ! validateNumberWithPlus(mobileNumber.value) ) {
                    popModalMessage.innerHTML = "<p>Please enter phone number <br/> (up to 15 digits).</p>";
                    return;
                }   
            }
            
            if( departureDate.value == '' ) {
                glide_ajax_loader_hide();
                popModalMessage.innerHTML = "<p>Please select departure date.</p>";
                return;
            }

            nearbyPharmacyCreatePhoneToken(mobileNumber.value, searchLat.value, searchLng.value, filterType.value, departureDate.value);
        });
    }

    /****************************************
     * function filter nearby pharmacy 
     * create patient phone token
     ***************************************/
    function nearbyPharmacyCreatePhoneToken (mobileNumber, searchLat, searchLng, filterType, departureDate) {
        let request = new XMLHttpRequest();
        let pharmacyFilterElement = document.querySelector("#pharmacy-filter-nearby");
        let pharmacyFilterModal = document.querySelector(".message-text");
    
        request.open("POST", glide_custom_data.ajax_url, true);
        request.setRequestHeader(
            "Content-Type",
            "application/x-www-form-urlencoded; charset=UTF-8"
        );
    
        glide_ajax_loader_show();
    
        request.onreadystatechange = () => {
            glide_ajax_loader_hide();
            if (request.readyState === 4 && request.status === 200) {
                let $html = JSON.parse(request.response);
                let feedbackToken = $html.data.token;
                console.log('Token: ' + feedbackToken);
                console.log('Sms: ' + $html.data.sms);
                
                // if user token generated is less than 8 weeks
                if( feedbackToken == 'confuguration' ) {
                    modalMessage = "<p>Twilio configuration failure.</p>";
                } else {
                    modalMessage = "<p>Pharmacy list results</p>";
                }
                pharmacyFilterElement.innerHTML = $html.data.message;
                pharmacyFilterModal.innerHTML = modalMessage;
                document.querySelector("#click-submit").value = "submit";
                pharmacyFilterElement.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
                setTimeout(() => {
                    document.querySelector(".pop-modal .btn-close").click();
                }, 1000);
            } else {
                pharmacyFilterModal.innerHTML = "<p>Our system is facing <br> technical issues. <br> Please try again <br> in a few minutes</p>";
            }
        };

        const postData =
        `action=glide_nearby_pharmacy_create_phone_token&nonce=${encodeURIComponent(
            glide_custom_data.ajax_nonce
        )}&filterType=` +filterType + `&searchLat=` +searchLat + `&searchLng=` +searchLng + `&mobileNumber=` +mobileNumber + `&departureDate=` +departureDate;
        request.send(postData);
    
    }

})();